import { auth } from "../../Firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from "firebase/auth";
import { toast } from "react-toastify";
import { CONNEXION_NAVIGATION } from "../../Routes/NAVIGATION_PATH";
import { authRoutes } from "../../Routes/routes";
export const registerUser = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const loginUser = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOutUser = (navigate) => {
  signOut(auth)
    .then(() => {
      sessionStorage.clear();
      toast.success("La déconnexion à bien reussie!");
      navigate('/')
      window.location.reload();
    })
    .catch((error) => {
      toast.error("Erreur, réessayer!");
      const errorCode = error.code;
      console.log(errorCode);
    });
};

export const UpdatePassword = (newPassword) => {
  updatePassword(auth.currentUser, newPassword).then(() => {
    // Update successful.
    toast.success("Mot de passe modifié avec succès !");
  }).catch((error) => {
    // An error ocurred
    toast.error("Erreur, réessayer!");
    console.error("Error updating password: ", error);
  });
}